import { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import { MessageSquare, ChevronDown, Calendar }                 from 'react-feather'
import { ExpandableBlock, Pagination, ActivityEmissions, FormError } from '@/Components/'
import { LabeledInput }                                              from "@/Components/Form";
import { formatDate } from "@/Utilities/Utilities";
import { CalculatorChangelogItem } from "@/Components/Calculators/CalculatorChangelogItem";
import { DynamicInputType } from "@/Components/Questions/InputTypes/Report";

export const CalculatorActivity = forwardRef(({
  calculator,
  question = null,
  errors = null,
  setFormState = () => {},
  siblingRefs = [],
  index = null,
}, ref) => {

    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
      if (errors && !isOpen && (errors?.[`reportedActivities.${question.id}.select_option_id`] || errors?.[`reportedActivities.${question.id}.value`])) {
        setIsOpen(true);
      }
    }, [errors]);

    useImperativeHandle(ref, () => ({
      changeOpenState(flag) {
        setIsOpen(flag);
      },
    }), [isOpen]);

    function resetAndToggleOpen(flag) {
      setIsOpen(flag);
      siblingRefs.at(index + 1)?.current?.changeOpenState(true);
    }

    return (
      <ExpandableBlock overrideOpen={setIsOpen} heading={question.title} isOpen={isOpen} byline={<ActivityEmissions className="hidden md:inline-block" value={0} light={true} />}>
        <div className="flex flex-col w-full gap-4 mb-4 md:flex-row">
          <div className="flex flex-col shrink-0 grow-0 basis-1/2">
            <span className="block mb-1">Reporting period</span>
            <div className="flex flex-row items-center justify-start px-3 py-1 bg-white border h-14 border-borderColor datepicker-container shrink">
              <Calendar size={18} className="relative z-10 mr-1 pointer-events-none"/>
              <span className="mt-1">{formatDate(calculator.start_date)}</span>
              <span className="mx-2 mt-1">&ndash;</span>
              <span className="mt-1">{formatDate(calculator.end_date)}</span>
            </div>
          </div>
          {/*<div className="flex flex-col items-start shrink-0 grow basis-1/2">*/}
          {/*  <span>Reported</span>*/}
          {/*  <div className="h-14 mt-1 flex items-center">*/}
          {/*    {reported_activity && (*/}
          {/*      <>*/}
          {/*        <span className="p-1 m-0 text-sm">*/}
          {/*          {formatEmissions(recipient.entry_values.filter(v => v.activity.id === activity.id).reduce((acc, val) => acc + val.value, 0))} {unit}*/}
          {/*        </span>*/}
          {/*        <ActivityEmissions value={entry?.co2e || 0} light={true} />*/}
          {/*      </>*/}
          {/*    )}*/}
          {/*    {!reported_activity && (*/}
          {/*      <span className="text-sm">Not submitted yet</span>*/}
          {/*    )}*/}
          {/*  </div>*/}
          {/*</div>*/}
        </div>

        <DynamicInputType question={question}/>

        <div className="flex justify-end mt-4">
          <button className="btn" onClick={() => resetAndToggleOpen(false)}>{ siblingRefs.length - 1 === index ? 'Close':  'Next' }</button>
        </div>
      </ExpandableBlock>
    )
})
